import React, {
  useContext,
  useCallback,
  useMemo,
  useEffect,
  useState,
} from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  TextField,
  Grid,
  InputAdornment,
  Pagination,
  Stack,
  Backdrop,
  useTheme,
  Typography,
  MenuItem,
  Popover,
} from "@mui/material";
import dayjs from "dayjs";
import DownloadIcon from "@mui/icons-material/Download";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import useMediaQuery from "@mui/material/useMediaQuery";
import { PAGE_SIZE } from "../../Services/common/const";
import Title from "../../Components/Title";
import ShortcutButton from "../../Components/ShortcutButton";
import { PreferencesContext } from "../../PreferencesContext";
import MissingConsumer from "../../Components/MissingConsumer";
import {
  ExportFilesFunction,
  numberFormat,
  useQuery,
} from "../../shared/CommonFuctions";
import { KeyboardArrowDownSharp } from "@mui/icons-material";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import SplashComponent from "../../Navigation/splash";
import { AlertType } from "../../shared/Modal/AlertType";
import { EncryptDecryptService } from "../../Services/common/EncryptionService";
import { StyledMenu } from "../../Components/StyleMenus";
import { format } from "date-fns";
import CustomDateRangePicker from "../../Components/CustomDateRange";
import {
  GetExpenseVehicleReport,
  GetPossibleBOMCountByAvailableStockReport,
} from "../../Services/ReportService";
import { GetPossibleBOMCountByAvailableStock } from "../../Services/BillOfMaterialService";
import { GetWarehouseList } from "../../Services/WarehouseService";
import MultiSelectSim from "../../Components/MultiSelectSimple";

const parameters = {
  consumerId: 25,
  branchId: 1,
  pageIndex: 1,
  pageSize: PAGE_SIZE,
  sortColumn: "",
  sortDirection: "",
  searchValue: "",
  lessThanValue: "",
};

interface Data {
  billOfMaterialId: number;
  bomName: string;
  possibleBomCount: number;
}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort<T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number
) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export default function PossibleBOMCountByAvailableStock() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  const [isLoading, setLoading] = useState(false);
  const [order, setOrder] = useState<Order>("");
  const [orderBy, setOrderBy] = useState<keyof Data>("none");
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [param, setParam] = useState(parameters);
  const [fromDate, setFromDate] = useState<any>(
    userContext.financialYearStartDate
  );

  const [selectedVoucherTypes, setSelectedVoucherTypes] = useState<string[]>(
    []
  );
  const [toDate, setToDate] = useState<any>(userContext.financialYearEndDate);
  const [resultData, setResultData] = useState<Data[]>([]);
  const [warehouseCollection, setWarehouseCollection] = useState<any>([]);
  const [warehouseSelectedOption, setWarehouseSelectedOption] =
    React.useState<any>([]);
  const [selectedWarehouseIdData, setSelectedWarehouseIdData] =
    React.useState<any>([]);
  const startDate = new Date(userContext.financialYearStartDate);
  const endDate = new Date(userContext.financialYearEndDate);
  const [selectedDateRange, setDateRange] = useState<any>([
    {
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    },
  ]);
  const [anchorEl2, setAnchorEl2] = useState<null | HTMLElement>(null);
  const mobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const matches = useMediaQuery("(max-width:425px)");
  const edService = new EncryptDecryptService();
  const openExportType = Boolean(anchorEl2);
  const [anchorEl0, setAnchorEl0] = React.useState<HTMLButtonElement | null>(
    null
  );

  const location = useLocation();
  let urlParams = useQuery();
  const encryptedLabelId = urlParams.get("q");
  let decryptLabelId: any = edService.decrypt(encryptedLabelId);
  let convertedLabelId: any = parseInt(decryptLabelId) || 0;

  const pageInfo = useMemo(
    () => ({
      startIndex: (page - 1) * PAGE_SIZE + 1,
      endIndex: (page - 1) * PAGE_SIZE + resultData.length,
      totalPages: Math.ceil(totalCount / PAGE_SIZE),
    }),
    [page, resultData.length, totalCount]
  );

  const handleSearch = useCallback((val: string) => {
    setSearchValue(val);
    setPage(1);
    setParam((prev) => ({ ...prev, searchValue: val, pageIndex: 1 }));
  }, []);

  const handlePageChange = useCallback(
    (event: React.ChangeEvent<unknown>, value: number) => {
      setPage(value);
      setParam((prev) => ({ ...prev, pageIndex: value }));
    },
    []
  );

  const handleCloseDate = () => {
    setAnchorEl0(null);
  };

  const handleWarehouseId = (object: any) => {
    setWarehouseSelectedOption(object);
    let warehouseIdData: any = [];

    object.forEach((x) => {
      if (x?.value === "*") {
        return;
      } else {
        let warehouseIds = x.warehouseId;
        x.warehouseId = warehouseIds;
        warehouseIdData.push(warehouseIds.toString());
      }
    });
    setSelectedWarehouseIdData(warehouseIdData);
  };
  //   const handleMoveToVoucher = useCallback(
  //     async (vehicleId: number) => {
  //       try {
  //         const encVehicleId = edService.encrypt(vehicleId.toString());
  //         navigate({
  //           pathname: "/expense-voucher",
  //           search: `?q=${encodeURIComponent(encVehicleId || "")}`,
  //         });
  //       } catch (e: any) {
  //         updateUserContext({
  //           ...userContext,
  //           isAlert: true,
  //           alertMessage: typeof e === "string" ? e : e?.message,
  //           alertType: AlertType.Error,
  //         });
  //       }
  //     },
  //     [navigate, edService, userContext, updateUserContext]
  //   );

  async function fetchWarehouseList() {
    try {
      let params = new URLSearchParams();
      let warehouseList: any;
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("pageIndex", page.toString());
      params.append("pageSize", PAGE_SIZE.toString());
      params.append("sortColumn", param.sortColumn);
      params.append("sortDirection", param.sortDirection);
      params.append("searchValue", param.searchValue);
      params.append("mode", "");

      const result: any = await GetWarehouseList(params);
      if (result && result.data.data) {
        warehouseList = result.data?.data?.warehouseCollection;
        setWarehouseCollection(warehouseList);
      } else {
      }
      return warehouseList;
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  async function fetchPossibleBOMCountByAvailableStock() {
    try {
      setLoading(true);
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("warehouseIds", selectedWarehouseIdData || "");
      params.append("pageIndex", page.toString());
      params.append("pageSize", PAGE_SIZE.toString());
      params.append("sortColumn", param.sortColumn);
      params.append("sortDirection", param.sortDirection);
      params.append("searchValue", param.searchValue);
      params.append("financialYear", userContext.financialYear.toString());
      params.append("mode", "LIST");
      const result: any = await GetPossibleBOMCountByAvailableStock(params);
      if (result && result.data.data) {
        let bomInfo =
          result.data.data?.possibleBOMCountByAvailableStockCollection;
        let dataCount = result.data.data.totalCount;
        setResultData(bomInfo);
        setTotalCount(dataCount);
        setLoading(false);
      } else {
        console.log("Error");
        setLoading(false);
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  async function handelBOMReportPopup(type: any) {
    setAnchorEl2(null);
    setLoading(true);
    let params = new URLSearchParams();
    var attachmentName = "";
    if (type === "pdf") {
      attachmentName = "PossibleBOMCountByAvailableStockReport.pdf";
    } else {
      attachmentName = "PossibleBOMCountByAvailableStockReport.xls";
    }
    params.append("reportName", "PossibleBOMCountByAvailableStockReport");
    params.append("reportType", type);
    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("branchId", userContext.branchId.toString());
    params.append("warehouseIds", selectedWarehouseIdData || "");
    params.append("pageIndex", page.toString());
    params.append("pageSize", PAGE_SIZE.toString());
    params.append("sortColumn", param.sortColumn);
    params.append("sortDirection", param.sortDirection);
    params.append("searchValue", searchValue);
    // params.append("startDate", format(new Date(fromDate), "yyyy-MM-dd"));
    // params.append("endDate", format(new Date(toDate), "yyyy-MM-dd"));
    params.append("financialYear", userContext.financialYear.toString());
    params.append("mode", "EXPORT");
    try {
      const result: any = await GetPossibleBOMCountByAvailableStockReport(params);

      if (result && result.data && result.data.data) {
        var fileContent = result?.data?.data?.fileData;
        var attachmentData = fileContent;
        ExportFilesFunction(attachmentName, type, attachmentData);
        setLoading(false);
      }
      setLoading(false);
    } catch (e: any) {
      // setLoading(false);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchPossibleBOMCountByAvailableStock();
    fetchWarehouseList();
  }, [page, param, selectedWarehouseIdData]);

  const handleCloseExportType = () => {
    setAnchorEl2(null);
  };

  const handleClickExportType = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl2(event.currentTarget);
  };

  const TableHeader = React.memo(() => (
    <TableHead>
      <TableRow>
        <TableCell
          sx={{
            display: {
              xs: "table-cell",
              sm: "table-cell",
              md: "table-cell",
              lg: "table-cell",
            },
            fontWeight: "bold",
            minWidth: "80px",
          }}
          align="left">
          {"BOM Name"}
        </TableCell>
        <TableCell
          sx={{
            display: {
              xs: "table-cell",
              sm: "table-cell",
              md: "table-cell",
              lg: "table-cell",
            },
            fontWeight: "bold",
            minWidth: "80px",
          }}
          align="center">
          {"Possible Bom Count"}
        </TableCell>
      </TableRow>
    </TableHead>
  ));


  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          backgroundColor: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}>
        <SplashComponent />
      </Backdrop>
      <Title pageTitle="Possible BOM Count By Available Stock" />

      {userContext.consumerId > 0 ? (
        <Box
          className="boxContainer"
          sx={{
            "& > :not(style)": {
              width: "100%",
            },
          }}>
          <Grid
            className="title-button-responsive"
            item
            xs={6}
            md={3}
            sx={{
              display: "flex !important",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
            <h4 className="page-title">Possible BOM Count By Available Stock</h4>

            <Grid
              item
              xs={6}
              md={3}
              marginRight={0}
              textAlign="end"
              paddingTop="0px">
              <Button
                variant="outlined"
                onClick={() => navigate(-1)}
                size="medium"
              >
                <ShortcutButton label="ESC" />
                Back
              </Button>
            </Grid>
          </Grid>
          <Grid className="paper top-space">
            <Paper elevation={4} className="paper-container">
              <Grid
                container
                spacing={1}
                sx={{ marginTop: "10px" }}
                className="search-space">
                <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
                  <TextField
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        handleSearch(searchValue);
                      }
                    }}
                    sx={{ paddingLeft: "0px !important", width: "100%" }}
                    className="button-responsive-stock"
                    placeholder="Search..."
                    type="text"
                    variant="outlined"
                    size="small"
                    onChange={(e) => setSearchValue(e.target.value)}
                    value={searchValue}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => handleSearch(searchValue)}>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                      endAdornment: searchValue && (
                        <IconButton onClick={() => handleSearch("")}>
                          <ClearIcon />
                        </IconButton>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={3} lg={2} xl={2}></Grid>
                {/* <Grid item xs={12} sm={3} md={3}>
                  <MultiSelectSim
                    key="WarehouseId"
                    placeholder="Select Warehouse.."
                    options={warehouseCollection}
                    onChange={handleWarehouseId}
                    value={warehouseSelectedOption}
                    isSelectAll={true}
                    menuPlacement={"bottom"}
                  />
                </Grid> */}
                <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
                  <Grid
                    sx={{
                      height: "100%",
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "center",
                      gap: "20px",
                      flexDirection: matches ? "column" : "row",
                    }}>
                    {/* <CustomDateRangePicker
                      fromDate={fromDate}
                      setFromDate={setFromDate}
                      toDate={toDate}
                      setToDate={setToDate}
                    /> */}
                    <MultiSelectSim
                      key="WarehouseId"
                      placeholder="Select Warehouse.."
                      options={warehouseCollection}
                      onChange={handleWarehouseId}
                      value={warehouseSelectedOption}
                      isSelectAll={true}
                      menuPlacement={"bottom"}
                    />
                    <Popover
                      open={Boolean(anchorEl0)}
                      anchorEl={anchorEl0}
                      onClose={handleCloseDate}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}></Popover>
                    <Button
                      className="button-responsive-stock"
                      aria-controls={
                        openExportType ? "demo-customized-menu" : undefined
                      }
                      aria-haspopup="true"
                      aria-expanded={openExportType ? "true" : undefined}
                      disabled={resultData?.length <= 0}
                      variant="outlined"
                      disableElevation
                      onClick={handleClickExportType}
                      startIcon={<DownloadIcon />}
                      endIcon={<KeyboardArrowDownSharp />}>
                      Export
                    </Button>
                    <StyledMenu
                      id="demo-customized-menu"
                      MenuListProps={{
                        "aria-labelledby": "demo-customized-button",
                      }}
                      anchorEl={anchorEl2}
                      open={openExportType}
                      onClose={handleCloseExportType}>
                      <MenuItem
                        disableRipple
                        onClick={() => handelBOMReportPopup("pdf")}>
                        PDF
                      </MenuItem>
                      <MenuItem
                        disableRipple
                        onClick={() =>
                          handelBOMReportPopup("Excel")
                        }>
                        EXCEL
                      </MenuItem>
                    </StyledMenu>
                  </Grid>
                </Grid>
              </Grid>

              <TableContainer>
                <Table aria-labelledby="tableTitle" size="medium">
                  {/* Table Head */}
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{ fontWeight: "bold", minWidth: "80px" }}
                        align="left">
                        BOM Name
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", minWidth: "120px" }}
                        align="center">
                        Possible Bom Count
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  {/* Table Body */}
                  {resultData?.length > 0 ? (
                    <TableBody>
                      {stableSort(
                        resultData,
                        getComparator(order, orderBy)
                      ).map((item, index) => (
                        <TableRow key={index}>
                          <TableCell align="left">
                            {item?.bomName}
                          </TableCell>
                          <TableCell align="center"
                            className={
                              item?.possibleBomCount <= 0
                                ? "red-color"
                                : item?.possibleBomCount <= 10
                                  ? "blue-color"
                                  : ""
                            }>
                            {/* {item?.possibleBomCount} */}
                            {numberFormat(item?.possibleBomCount)}
                          </TableCell>
                        </TableRow>
                      ))}

                      {/* Totals Row */}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={11} align="center">
                          No record(s) found
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
                {resultData?.length > 0 && (
                  <Grid
                    container
                    paddingTop={1}
                    alignItems={"center"}
                    justifyContent={"center"}>
                    <Grid item xs={12} sm={6} className="pagination-label">
                      {pageInfo.startIndex} - {pageInfo.endIndex} of{" "}
                      {totalCount}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Stack
                        component="div"
                        alignItems={mobileScreen ? "center" : "end"}
                        justifyContent={"center"}>
                        <Pagination
                          color="primary"
                          count={pageInfo.totalPages}
                          page={page}
                          onChange={handlePageChange}
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                )}
              </TableContainer>
            </Paper>
          </Grid>
        </Box>
      ) : (
        <Box
          className="boxContainer"
          sx={{
            "& > :not(style)": {
              width: "100%",
            },
          }}>
          <MissingConsumer consumerId={userContext.consumerId} />
        </Box>
      )}
    </>
  );
}
